export default "__VITE_ASSET__C39mS2iu__"